export default __webpack_public_path__ + "static/media/otra-vida-tattoo_hero-image.15a3069e.webp";